export default "__VITE_ASSET__DpBCCqbm__"